export default {
  "Homepage only": "Hanya homepage",
  "Restores just the front page, with its images, CSS, fonts and scripts. Much faster. Links to other pages stay in place, but those pages are not downloaded.":
    "Hanya memulihkan halaman depan, lengkap dengan gambar, CSS, font, dan script-nya. Jauh lebih cepat. Link ke halaman lain tetap ada, tapi halaman-halaman itu tidak diunduh.",
  "page: only the homepage (of {n} available)": "halaman: hanya homepage (dari {n} yang tersedia)",
  // page header, actions, toasts
  "Analysis started": "Analisis dimulai",
  "Domain deleted": "Domain dihapus",
  "View progress": "Lihat progres",
  "Analyze archive": "Analisis arsip",
  "Download ZIP": "Unduh ZIP",
  "Start recovery": "Mulai pemulihan",
  "Domains": "Domain",
  "{captures} captures · {pages} pages · {from}–{to}": "{captures} rekaman arsip · {pages} halaman · {from}–{to}",
  "A capture is one saved copy of a page, made by the Internet Archive on a certain date.": "Satu rekaman arsip adalah satu salinan halaman yang disimpan Internet Archive pada tanggal tertentu.",
  "Analyzed {time}": "Dianalisis {time}",
  "Open latest result": "Buka hasil terbaru",
  "New recovery": "Pemulihan baru",
  "Analyze again": "Analisis ulang",
  "Refresh the archive history": "Perbarui riwayat arsip",
  "Analyze with Common Crawl": "Analisis dengan Common Crawl",
  "Also collect URL hints from Common Crawl": "Kumpulkan juga petunjuk URL dari Common Crawl",
  "Browse archived URLs": "Telusuri URL yang diarsipkan",
  "Domain settings": "Pengaturan domain",
  "Delete domain": "Hapus domain",
  "Removes its jobs and files": "Menghapus semua proses dan file-nya",
  "Delete {name} and everything recovered for it?": "Hapus {name} beserta semua hasil pemulihannya?",
  "Analyzing the archive history": "Menganalisis riwayat arsip",
  "Recovering the website": "Memulihkan website",
  "starting": "memulai",
  "Details": "Detail",
  "Latest recovery is ready": "Pemulihan terbaru sudah siap",
  "View result": "Lihat hasil",
  "Download the ZIP before it expires {time} ({date}). After that the files are deleted from the server.": "Unduh ZIP sebelum kedaluwarsa {time} ({date}). Setelah itu file dihapus dari server.",
  "Files of the latest recovery were deleted": "File pemulihan terbaru sudah dihapus",
  "Open job": "Buka proses",
  "They are kept on the server for a limited time only. Open the job and choose Run again to rebuild them.": "File hanya disimpan di server untuk waktu terbatas. Buka prosesnya lalu pilih Jalankan lagi untuk membuatnya ulang.",
  "The latest recovery failed": "Pemulihan terbaru gagal",
  "See why": "Lihat penyebab",
  "Archive history": "Riwayat arsip",
  "Recover": "Pulihkan",
  "Jobs": "Proses",
  "Backlinks": "Backlink",

  // step guide
  "Reading the archive history…": "Membaca riwayat arsip…",
  "History and website versions found": "Riwayat dan versi website ditemukan",
  "Find what the archive has": "Cari tahu isi arsip",
  "Choose snapshot": "Pilih snapshot",
  "Pick the date or let us recommend one": "Pilih tanggal atau gunakan rekomendasi kami",
  "Recover & download": "Pulihkan & unduh",
  "Downloading and rebuilding…": "Mengunduh dan membangun ulang…",
  "ZIP and reports created": "ZIP dan laporan sudah dibuat",
  "Rebuild the site and get a ZIP": "Bangun ulang situs dan dapatkan ZIP",

  // archive history tab
  "Loading archive history…": "Memuat riwayat arsip…",
  "Analysis in progress": "Analisis sedang berjalan",
  "Not analyzed yet": "Belum dianalisis",
  "The archive history appears here as soon as the analysis finishes.": "Riwayat arsip muncul di sini begitu analisis selesai.",
  "Analyzing reads the full capture history from the Internet Archive. It takes about a minute.": "Analisis membaca seluruh riwayat rekaman arsip dari Internet Archive. Prosesnya sekitar satu menit.",
  "Recommended period: {label}": "Periode yang direkomendasikan: {label}",
  "Snapshot of {date} — the most complete version of the site in the archive.": "Snapshot {date} — versi situs paling lengkap di arsip.",
  "Use this period": "Gunakan periode ini",
  "Pages available": "Halaman tersedia",
  "of {n} pages found": "dari {n} halaman ditemukan",
  "Images, CSS & files": "Gambar, CSS & file",
  "of {n} found": "dari {n} ditemukan",
  "Website versions": "Versi website",
  "Separate designs over time": "Desain berbeda dari waktu ke waktu",
  "Archived since": "Diarsipkan sejak",
  "Last capture {date}": "Rekaman arsip terakhir {date}",
  "Archive coverage by year": "Cakupan arsip per tahun",
  "How much of the site the Internet Archive captured each year.": "Seberapa banyak bagian situs yang direkam Internet Archive setiap tahun.",
  "Captures per year": "Rekaman arsip per tahun",
  "{year}: {pages} pages, {files} files": "{year}: {pages} halaman, {files} file",
  "Pages": "Halaman",
  "Year-by-year details": "Detail per tahun",
  "Year": "Tahun",
  "Available": "Tersedia",
  "Files": "File",
  "Homepage captures": "Rekaman arsip beranda",
  "How many times the Internet Archive saved a copy of the homepage that year.": "Berapa kali Internet Archive menyimpan salinan beranda pada tahun itu.",
  "Coverage*": "Cakupan*",
  "Estimated share of that year's pages that have at least one usable saved copy. Higher means more of the site can be restored.": "Perkiraan porsi halaman tahun itu yang punya minimal satu salinan tersimpan yang bisa dipakai. Makin tinggi, makin banyak bagian situs yang bisa dipulihkan.",
  "* Estimate: share of pages captured that year with at least one successful capture. Pages the archive never saw cannot be counted.": "* Perkiraan: porsi halaman yang direkam tahun itu dengan minimal satu rekaman arsip yang berhasil. Halaman yang tidak pernah terekam arsip tidak bisa dihitung.",
  "The same domain can have different designs or owners over time. Each version is restored on its own and never mixed with another.": "Satu domain bisa punya desain atau pemilik berbeda dari waktu ke waktu. Setiap versi dipulihkan sendiri dan tidak pernah dicampur dengan versi lain.",
  "Different designs or owners over time. They are never mixed into one restored site.": "Desain atau pemilik berbeda dari waktu ke waktu. Versi-versi ini tidak pernah dicampur menjadi satu situs yang dipulihkan.",
  "Homepage · {date}": "Beranda · {date}",
  "Recommended": "Direkomendasikan",
  "Homepage": "Beranda",
  "Example pages": "Contoh halaman",
  "Parked / for sale": "Diparkir / dijual",
  "Spam on homepage: {categories}": "Spam di beranda: {categories}",
  "{n} spam URL": "{n} URL spam",
  "{n} spam URLs": "{n} URL spam",

  // recover tab
  "Specific date": "Tanggal tertentu",
  "Date range": "Rentang tanggal",
  "We pick the most complete version of the site.": "Kami memilih versi situs yang paling lengkap.",
  "The site exactly as it was on a chosen date.": "Situs persis seperti pada tanggal yang dipilih.",
  "The latest version of each page within a period.": "Versi terbaru setiap halaman dalam satu periode.",
  "Analyze the domain first": "Analisis domain terlebih dahulu",
  "The recovery options appear once the archive history is known.": "Pilihan pemulihan muncul setelah riwayat arsip diketahui.",
  "What should be restored?": "Apa yang ingin dipulihkan?",
  "Recommended: the most complete version of the site, chosen for you.": "Direkomendasikan: versi situs paling lengkap, dipilih otomatis.",
  "Specific date: each page as it was on or just before the date you pick.": "Tanggal tertentu: setiap halaman seperti pada tanggal yang dipilih atau sesaat sebelumnya.",
  "Date range: the newest saved copy of each page within the period.": "Rentang tanggal: salinan tersimpan terbaru dari setiap halaman dalam periode itu.",
  "Restores the {label} website as it looked on {date}.": "Memulihkan website {label} seperti tampilannya pada {date}.",
  "Date (pick a homepage capture below, or type YYYYMMDD or a full 14-digit timestamp)": "Tanggal (pilih rekaman arsip beranda di bawah, atau ketik YYYYMMDD atau timestamp lengkap 14 digit)",
  "Each page uses its latest capture on or before this moment. Newer captures are never used.": "Setiap halaman memakai rekaman arsip terakhirnya pada atau sebelum waktu ini. Rekaman arsip yang lebih baru tidak pernah dipakai.",
  "How the homepage looked · {date}": "Tampilan beranda · {date}",
  "From (year or YYYYMMDD)": "Dari (tahun atau YYYYMMDD)",
  "To": "Sampai",
  "More options": "Opsi lainnya",
  "Keep older website versions separately": "Simpan versi lama website secara terpisah",
  "Older designs go into their own folder in the ZIP, never mixed into the main site.": "Desain lama masuk ke folder tersendiri di ZIP, tidak pernah dicampur ke situs utama.",
  "Full archive": "Arsip lengkap",
  "Every website version, each restored on its own.": "Semua versi website, masing-masing dipulihkan sendiri.",
  "Start Recovery": "Mulai Pemulihan",
  "Another job is running for this domain.": "Ada proses lain yang sedang berjalan untuk domain ini.",
  "Runs on the server — you can close this page.": "Berjalan di server — halaman ini boleh ditutup.",
  "What you will get": "Hasil yang didapat",
  "Choose a date to see the result.": "Pilih tanggal untuk melihat hasilnya.",
  "Checking the archive…": "Memeriksa arsip…",
  "pages in the main site": "halaman di situs utama",
  "pages in the main site ({label} version)": "halaman di situs utama (versi {label})",
  "Older versions, kept separately": "Versi lama, disimpan terpisah",
  "Pages from older website versions. They go into a separate folder in the ZIP and are never mixed into the main site.": "Halaman dari versi website lama. Halaman ini masuk ke folder terpisah di ZIP dan tidak pernah dicampur ke situs utama.",
  "Not available for this date": "Tidak tersedia untuk tanggal ini",
  "Snapshot": "Snapshot",
  "Why some pages are not available": "Mengapa sebagian halaman tidak tersedia",
  "Images, CSS and scripts are added automatically during the recovery.": "Gambar, CSS, dan skrip ditambahkan otomatis selama pemulihan.",

  // jobs tab
  "No jobs yet": "Belum ada proses",
  "Recovery": "Pemulihan",
  "Analysis": "Analisis",
  "Files deleted": "File dihapus",
  "Files expire {time}": "File kedaluwarsa {time}",

  // backlinks tab
  "{n} backlink targets imported": "{n} target backlink diimpor",
  "{n} URLs imported": "{n} URL diimpor",
  "Backlink targets": "Target backlink",
  "Import an Ahrefs export to see which linked pages were restored. Pages that are linked but missing are listed first.": "Impor ekspor Ahrefs untuk melihat halaman bertautan mana yang sudah dipulihkan. Halaman yang ditautkan tetapi hilang ditampilkan paling atas.",
  "Import Ahrefs CSV": "Impor CSV Ahrefs",
  "Known URLs, e.g. from an old sitemap": "URL yang diketahui, misalnya dari sitemap lama",
  "URL list": "Daftar URL",
  "No backlink data yet. Metrics are stored exactly as exported; nothing is estimated.": "Belum ada data backlink. Metrik disimpan persis seperti hasil ekspor; tidak ada yang diperkirakan.",
  "{n} linked page is not in the restored site": "{n} halaman bertautan tidak ada di situs yang dipulihkan",
  "{n} linked pages are not in the restored site": "{n} halaman bertautan tidak ada di situs yang dipulihkan",
  "All linked pages are restored": "Semua halaman bertautan sudah dipulihkan",
  "Linked page": "Halaman bertautan",
  "Ref. domains": "Domain perujuk",
  "Status": "Status",

  // settings modal
  "Parallel downloads": "Unduhan paralel",
  "Archive requests per second": "Permintaan arsip per detik",
  "Allow newer image/CSS captures (days)": "Izinkan rekaman arsip gambar/CSS yang lebih baru (hari)",
  "Recover files hosted on other sites (CDNs)": "Pulihkan file yang di-host di situs lain (CDN)",
  "Download audio and video": "Unduh audio dan video",
  "Disable contact forms": "Nonaktifkan formulir kontak",
  "Domain settings saved": "Pengaturan domain disimpan",
  "Only for this domain. Leave a field on “Default” to use the global settings.": "Hanya untuk domain ini. Biarkan kolom pada “Bawaan” untuk memakai pengaturan global.",
  "Cancel": "Batalkan",
  "Save": "Simpan",
  "Include subdomains": "Sertakan subdomain",
  "e.g. blog.{domain}. Analyze again after changing this.": "mis. blog.{domain}. Analisis lagi setelah mengubah ini.",
  "Default": "Bawaan",
  "Yes": "Ya",
  "No": "Tidak",
  "Notes": "Catatan",
} as Record<string, string>;
